/**
 * A faux "now playing" app screen for the hero. Stands in for a real
 * screenshot until we have one; built from the brand palette.
 */
const PhoneMock = () => {
  return (
    <div className="phone-stage">
      <div
        className="phone"
        role="img"
        aria-label="StreamLover app, now playing screen"
      >
        <div className="phone__screen">
          <div className="phone__statusrow">
            <span className="onair">
              <span className="dot" /> ON AIR
            </span>
            <span>
              <i className="live-dot" /> 1,204 listening
            </span>
          </div>

          <div className="phone__art" aria-hidden="true" />

          <div className="phone__meta">
            <div className="phone__station">Midnight Diner Radio</div>
            <div className="track">Cassette Summer</div>
            <div className="host">hosted by Jules — dedications open</div>
          </div>

          <div className="eq" aria-hidden="true">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>

          <div className="phone__controls" aria-hidden="true">
            <span className="ctl">♥</span>
            <span className="play">▶</span>
            <span className="ctl">⤳</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneMock;
